import React from 'react';
import {
	FaUser,
	FaHome,
	FaBeer,
	FaChrome,
	FaGithub,
	FaKiss,
	FaShoppingCart
} from 'react-icons/fa';
import { IoIosAirplane, IoIosArrowDown, IoMdPlay } from 'react-icons/io';
import { MdAlarm } from 'react-icons/md';
import { TiWiFi } from 'react-icons/ti';
import pageWrapper from '../../hoc/pageWrapper';
import {
	Section,
	H1, H2, H3, H4, H5, H6,
	Container, Columns, Column,
	A,
	Ul, Li,
	Button, LinkButton, IconButton,
	P,
	RspImageBg
} from '../../components/base';
import {
	backgroundImageStyles,
	Cube
} from './styleguide.styles';
import { theme } from '../../components/global';
import { ReactComponent as IconSofa } from '../../figures/sofa.svg';
import { ReactComponent as IconArrowDown } from '../../figures/arrow-down.svg';
import { ReactComponent as IconArrowLeftWhite } from '../../figures/arrow-left-white.svg';
import { ReactComponent as IconArrowRightWhite } from '../../figures/arrow-right-white.svg';
import { ReactComponent as IconBed } from '../../figures/bed.svg';
import { ReactComponent as IconDoor } from '../../figures/door.svg';
import { ReactComponent as IconFacebook } from '../../figures/facebook.svg';
import { ReactComponent as IconFm2 } from '../../figures/fm2.svg';
import { ReactComponent as IconGraphics } from '../../figures/graphics.svg';
import { ReactComponent as IconInstagram } from '../../figures/instagram.svg';
import { ReactComponent as IconLock } from '../../figures/lock.svg';
import { ReactComponent as IconToilet } from '../../figures/toilet.svg';
import { ReactComponent as IconWasher } from '../../figures/washer.svg';

const Styleguide = () => {
	return (
		<Section margin="12rem 0">
			<Section>
				<Container>
					<H1>Rsp Image BG</H1>
					<RspImageBg styles={backgroundImageStyles} image="/media/3905/ibud-banner.png?width={width}&height={height}" />
				</Container>
			</Section>
			<Section>
				<Container>
					<H1>Anchors</H1>
					<div>
						<A>The quick brown fox jumps over the lazy dog</A>
					</div>
					<div>
						<span>Everyone marvels as </span>
						<A>The quick brown fox jumps over the lazy dog </A>
						<span>while admiring the cold weather</span>
					</div>
					<div>
						<A>The quick brown fox jumps over the lazy dog</A>
					</div>
				</Container>
			</Section>
			<Section>
				<Container>
					<H1>Lists</H1>
					<Ul>
						<Li>The quick brown fox jumps over the lazy dog</Li>
						<Li>The quick brown fox jumps over the lazy dog</Li>
						<Li>The quick brown fox jumps over the lazy dog</Li>
						<Li>The quick brown fox jumps over the lazy dog</Li>
						<Li>The quick brown fox jumps over the lazy dog</Li>
						<Li>The quick brown fox jumps over the lazy dog</Li>
					</Ul>
				</Container>
			</Section>
			<Section>
				<Container>
					<H1>Buttons</H1>
					<div style={{ marginBottom: '20px' }}>
						<Button marginRight>Default</Button>
						<Button marginRight disabled>Disabled</Button>
						<Button primary marginRight>Primary</Button>
						<Button secondary marginRight>Secondary</Button>
					</div>
					<div style={{ marginBottom: '20px' }}>
						<Button small marginRight>I'm small</Button>
						<Button large marginRight>I'm large</Button>
						<Button secondary loading>Loading</Button>
						<LinkButton marginRight>I look like a link</LinkButton>
						<Button large primary loading>I'm a lot of things</Button>
					</div>
					<div style={{ marginBottom: '20px' }}>
						<Button marginRight>
							<FaUser />
							<span>Icon button</span>
						</Button>
						<Button primary large marginRight>
							<span>Icon button</span>
							<FaHome />
						</Button>
						<IconButton small marginRight>
							<FaHome />
						</IconButton>
						<IconButton secondary marginRight>
							<FaHome />
						</IconButton>
						<IconButton large marginRight>
							<FaHome />
						</IconButton>
						<IconButton large marginRight>
							<FaHome />
						</IconButton>
					</div>
				</Container>
			</Section>
			<Section>
				<Container>
					<H1>Icons</H1>
					<ul>
						<li><strong>Font Awesome</strong></li>
						<li><strong>Iconicons</strong></li>
						<li><strong>Material Design Icons</strong></li>
						<li><strong>Typicons</strong></li>
						<li><strong>Github Octicons icons</strong></li>
						<li><strong>Feather</strong></li>
						<li><strong><a href="https://react-icons.netlify.com/#/" target="_blank" rel="noopener noreferrer">React Icons</a></strong></li>
					</ul>
					<Columns mt="3rem">
						<Column><FaHome /></Column>
						<Column><FaBeer /></Column>
						<Column><FaChrome /></Column>
						<Column><FaGithub /></Column>
						<Column><FaKiss /></Column>
						<Column><FaShoppingCart /></Column>
						<Column><IoIosAirplane /></Column>
						<Column><IoIosArrowDown /></Column>
						<Column><IoMdPlay /></Column>
						<Column><MdAlarm /></Column>
						<Column><TiWiFi /></Column>
					</Columns>
					<H1 marginTop marginBottom>Custom local icons</H1>
					<Columns>
						<Column><IconSofa style={{ maxHeight: '2rem', maxWidth: '2rem' }} /></Column>
						<Column><IconArrowDown style={{ maxHeight: '2rem', maxWidth: '2rem' }} /></Column>
						<Column><IconArrowLeftWhite style={{ maxHeight: '2rem', maxWidth: '2rem', background: 'gray' }} /></Column>
						<Column><IconArrowRightWhite style={{ maxHeight: '2rem', maxWidth: '2rem', background: 'gray' }} /></Column>
						<Column><IconBed style={{ maxHeight: '2rem', maxWidth: '2rem' }} /></Column>
						<Column><IconDoor style={{ maxHeight: '2rem', maxWidth: '2rem' }} /></Column>
						<Column><IconFacebook style={{ maxHeight: '2rem', maxWidth: '2rem' }} /></Column>
						<Column><IconFm2 style={{ maxHeight: '2rem', maxWidth: '2rem' }} /></Column>
						<Column><IconGraphics style={{ maxHeight: '2rem', maxWidth: '2rem' }} /></Column>
						<Column><IconInstagram style={{ maxHeight: '2rem', maxWidth: '2rem' }} /></Column>
						<Column><IconLock style={{ maxHeight: '2rem', maxWidth: '2rem' }} /></Column>
						<Column><IconToilet style={{ maxHeight: '2rem', maxWidth: '2rem' }} /></Column>
						<Column><IconWasher style={{ maxHeight: '2rem', maxWidth: '2rem' }} /></Column>
					</Columns>
				</Container>
			</Section>
			<Section>
				<Container>
					<H1 marginBottom>Typography</H1>
					<div style={{ fontSize: '6rem', lineHeight: '6rem', fontWeight: '100' }}>Font weight 100</div>
					<div style={{ fontSize: '6rem', lineHeight: '6rem', fontWeight: '200' }}>Font weight 200</div>
					<div style={{ fontSize: '6rem', lineHeight: '6rem', fontWeight: '300' }}>Font weight 300</div>
					<div style={{ fontSize: '6rem', lineHeight: '6rem', fontWeight: '400' }}>Font weight 400</div>
					<div style={{ fontSize: '6rem', lineHeight: '6rem', fontWeight: '500' }}>Font weight 500</div>
					<div style={{ fontSize: '6rem', lineHeight: '6rem', fontWeight: '600' }}>Font weight 600</div>
					<div style={{ fontSize: '6rem', lineHeight: '6rem', fontWeight: '700' }}>Font weight 700</div>
					<div style={{ fontSize: '6rem', lineHeight: '6rem', fontWeight: '800' }}>Font weight 800</div>
					<div style={{ fontSize: '6rem', lineHeight: '6rem', fontWeight: '900' }}>Font weight 900</div>
					<P marginTop marginBottom>
						{
							`
								Lorem ipsum dolor sit amet, consectetur adipiscing elit,
								sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
								Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
								Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
								Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
							`
						}
					</P>
					<H1>The quick brown fox jumps over the lazy dog</H1>
					<H2>The quick brown fox jumps over the lazy dog</H2>
					<H3>The quick brown fox jumps over the lazy dog</H3>
					<H4>The quick brown fox jumps over the lazy dog</H4>
					<H5>The quick brown fox jumps over the lazy dog</H5>
					<H6>The quick brown fox jumps over the lazy dog</H6>
				</Container>
			</Section>
			<Section>
				<Container>
					<H1>Grid</H1>
					<Columns>
						<Column tablet={1 / 3}>
							<Cube background="primary" />
						</Column>
						<Column tablet={1 / 3}>
							<Cube background="primary" />
						</Column>
						<Column tablet={1 / 3}>
							<Cube background="primary" />
						</Column>
					</Columns>
					<Columns>
						<Column desktopSmall={1 / 5}>
							<Cube background="primary" />
						</Column>
						<Column desktopSmall={1 / 5}>
							<Cube background="primary" />
						</Column>
					</Columns>
					<Columns>
						<Column>
							<Cube background="primary" />
						</Column>
						<Column>
							<Cube background="primary" />
						</Column>
						<Column>
							<Cube background="primary" />
						</Column>
						<Column>
							<Cube background="primary" />
						</Column>
					</Columns>
				</Container>
			</Section>
			<Section>
				<Container>
					<H1>Colors</H1>
					<div>
						<span>Generator available at </span>
						<a href="https://palx.jxnblk.com/" target="_blank" rel="noopener noreferrer">Palx</a>
					</div>
					<Columns mt="3rem">
						{
							Object.keys(theme.colors).map((key, index) => (
								<Column key={index} tablet={1 / 9}>
									<Cube background={key} height="10rem">{key}</Cube>
								</Column>
							))
						}
					</Columns>
				</Container>
			</Section>
		</Section>
	);
};

Styleguide.propTypes = {
};

Styleguide.defaultProps = {
};

export default pageWrapper(Styleguide);
